import { Navigate, Outlet } from 'react-router-dom'
import usePermissions from '../hooks/usePermissions'

const ViewByPermission = ({ permissionKey }: { permissionKey: string }) => {
  const { has } = usePermissions()
  return has(permissionKey) ? <Outlet/> : <Navigate to="/404" />
}

export default ViewByPermission
